import { authAxios } from '@/lib/axios';

export async function startStripeCustomerPortal(
  returnUrl: string,
  { preferOpenInvoice = false }: { preferOpenInvoice?: boolean } = {},
): Promise<string> {
  const response = await authAxios.request<{ url?: string }>({
    url: '/api/subscriptions/stripe/customer-portal',
    method: 'POST',
    data: {
      return_url: returnUrl,
      prefer_open_invoice: preferOpenInvoice,
    },
  });
  const url = response.data?.url;
  if (typeof url !== 'string' || !url.startsWith('https://')) {
    throw new Error('stripe_portal_url_missing');
  }
  return url;
}
